import React, { useEffect, useRef, useState } from 'react';
import { Image } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

import { hasError } from 'components/base/ErrorFieldMessage';
import CampaignFilterableSelectModal from 'components/campaign/CampaignFilterableSelectModal';

import { TimeFormater, formatDate } from 'utils/TimeFormatUtil';

import deleteSelectedButton from 'assets/images/drop_down_delete_selected.png';
import NarrowUp from 'assets/images/drop_down_not_show_narrow.svg';

import './WechatContentInlineEditor.scss';

const DisplayItemWithNewLine = ({ itemText, isPreview }) => {
  const itemList = itemText?.split('\n');
  if (itemList?.length > 1) {
    return (
      <>
        {itemList?.map((item, index) => {
          if (index === 0) {
            return (
              <label className={`item-value ${isPreview ? 'preview' : ''}`}>
                {item}
              </label>
            );
          }
          return (
            <>
              <div className="next-line" />
              <label className={`item-value ${isPreview ? 'preview' : ''}`}>
                {item}
              </label>
            </>
          );
        })}
      </>
    );
  }
  return (
    <label className={`item-value ${isPreview ? 'preview' : ''}`}>
      {itemText}
    </label>
  );
};

export const WechatContentInlineDisplay = ({
  customStyle,
  contentText,
  textArgs,
  pattern = /{{\w+\.DATA}}/,
}) => {
  if (!contentText) {
    return null;
  }
  const elementList = [];
  const itemList = contentText?.split(pattern);
  if (itemList?.length > 1) {
    for (let i = 0; i < itemList.length; i++) {
      const item = itemList[i];
      if (i > 0 && textArgs?.[i - 1]) {
        elementList.push(textArgs[i - 1]);
      }
      elementList.push(item);
    }
    return (
      <div className={`create-section-inline-editor ${customStyle}`}>
        <DisplayItemWithNewLine
          itemText={elementList.join(' ')}
          isPreview={true}
        />
      </div>
    );
  }
  return (
    <div className={`create-section-inline-editor ${customStyle}`}>
      <DisplayItemWithNewLine itemText={contentText} isPreview={true} />
    </div>
  );
};

const WechatContentInlineEditor = ({
  customStyle,
  language,
  baseFieldName,
  contentText,
  pattern = /{{\w+\.DATA}}/,
}) => {
  const { clearErrors, getValues, watch, setValue, formState } =
    useFormContext();
  const { errors } = formState;

  const wechatBody = watch(baseFieldName);

  const [show, setShow] = useState(false);

  if (!contentText) {
    return null;
  }
  const variableRegex = /\{\{([a-z]+)\d+(\.DATA)\}\}/g;
  const variableParts = [];
  let match;
  while ((match = variableRegex.exec(contentText)) !== null) {
    variableParts.push(`${match[1]}${match[2]}`);
  }

  const itemList = contentText?.split(pattern);
  if (!!baseFieldName && itemList?.length > 1) {
    return (
      <div className={`create-section-inline-editor ${customStyle}`}>
        {itemList.map((item, index) => {
          if (index === 0) {
            return <DisplayItemWithNewLine itemText={item} />;
          }
          const fieldName = `${baseFieldName}.${index - 1}`;
          // const filedValue = getValues(fieldName);
          const filedValue = wechatBody?.[index - 1] || ''
          if (index === 1) {
            return (
              <>
                <div className="d-flex flex-column">
                  <div
                    className={`custom-insert-param-custom-input-container extended ${
                      hasError(errors, fieldName) ? 'field-has-error' : ''
                    }`}
                  >
                    <input
                      className="insert-param-custom-input"
                      name={fieldName}
                      type="text"
                      placeholder={'Please input/insert'}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      onChange={({ target }) => {
                        setValue(fieldName, target.value, {
                          shouldDirty: true,
                        });
                        clearErrors(fieldName);
                      }}
                      value={filedValue}
                      maxLength={20}
                    />
                    {filedValue && (
                      <Image
                        src={deleteSelectedButton}
                        className="filterable-dropdown-delete-selected"
                        onClick={(e) => {
                          e.stopPropagation();
                          setValue(fieldName, '', {
                            shouldDirty: true,
                          });
                        }}
                      />
                    )}
                    <div className="divider" />
                    <div
                      className="insert-param-click-area"
                      onClick={() => {
                        setShow(true);
                      }}
                    >
                      <label
                        className={
                          'btn-link-text-label btn-link-text-label-active'
                        }
                      >
                        {'Insert parameters'}
                      </label>
                      <Image
                        src={NarrowUp}
                        className={`filterable-toogle-area-indicator`}
                      />
                    </div>
                  </div>
                  <label class="tips-message">Max length: 20</label>
                </div>
                <DisplayItemWithNewLine itemText={item} />

                <CampaignFilterableSelectModal
                  show={show}
                  onClose={() => {
                    setShow(false);
                  }}
                  onSelect={(campaignData) => {
                    setValue(
                      fieldName,
                      `${campaignData.name}`.substring(0, 20),
                      { shouldDirty: true },
                    );
                    const temp = variableParts.forEach(
                      (fieldType, fieldTypeIndex) => {
                        if (fieldType === 'date.DATA') {
                          setValue(
                            `${baseFieldName}.${fieldTypeIndex}`,
                            `${formatDate(
                              campaignData.startDate,
                              TimeFormater.yearMonthDayTime,
                            )} ~ ${
                              campaignData.endDate
                                ? formatDate(
                                    campaignData.endDate,
                                    TimeFormater.yearMonthDayTime,
                                  )
                                : '2099-12-31 23:59'
                            }`,
                            { shouldDirty: true },
                          );
                        }
                      },
                    );
                    setShow(false);
                  }}
                  language={language}
                />
              </>
            );
          }
          if (['time.DATA', 'date.DATA'].includes(variableParts[index - 1])) {
            return (
              <>
                <div className="d-flex flex-column">
                  <div
                    className={`custom-insert-param-custom-input-container ${
                      hasError(errors, fieldName) ? 'field-has-error' : ''
                    }`}
                  >
                    <input
                      className="insert-param-custom-input custom-date-input "
                      name={fieldName}
                      type="text"
                      placeholder={'Please input/insert'}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      onChange={({ target }) => {
                        setValue(fieldName, target.value, {
                          shouldDirty: true,
                        });
                        clearErrors(fieldName);
                      }}
                      value={filedValue}
                    />
                  </div>
                  <label class="tips-message">
                    {
                      'Support Format: 2025-10-01 or 2025-10-01 14:00 or 2025-10-01 14:00 ~ 2025-10-31 23:59'
                    }
                  </label>
                </div>
                <DisplayItemWithNewLine itemText={item} />
              </>
            );
          }
          return (
            <>
              <div className="d-flex flex-column">
                <textarea
                  onChange={({ target }) => {
                    const value = target.value;
                    setValue(fieldName, value, { shouldDirty: true });
                    clearErrors(fieldName);
                  }}
                  className={`custom-textarea-input-box ${
                    hasError(errors, fieldName) ? 'field-has-error' : ''
                  }`}
                  value={filedValue}
                  maxLength={20}
                />
                <label class="tips-message">Max length: 20</label>
              </div>
              <DisplayItemWithNewLine itemText={item} />
            </>
          );
        })}
      </div>
    );
  }
  return (
    <div className={`create-section-inline-editor ${customStyle}`}>
      <DisplayItemWithNewLine itemText={contentText} />
    </div>
  );
};

export default WechatContentInlineEditor;
